// extracted by css-extract-rspack-plugin
export default {"referenceCard":"referenceCard-CxcmsZ"};